/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.1
 * @since 1.19.0
 */

import { Checkbox } from '../../../../../components/common';
import { useTableCheckboxApi } from '../../../api';
import { ITableCheckboxColumnProps } from './types';

const CheckboxCell = ({ checked, disabled, item }: Partial<ITableCheckboxColumnProps>) => {

    const { check } = useTableCheckboxApi();

    const onChecked = (checked: boolean) => {
        check(checked, item);
    };

    return <Checkbox checked={checked} disabled={disabled} onChange={onChecked}/>;
};

export default CheckboxCell;
